<template>
	<v-carousel cycle height="auto" hide-delimiter-background show-arrows-on-hover>
		<v-carousel-item eager v-for="(slide, i) in slides" :key="i">
			<v-img :src="slide" :lazy-src="slide" :aspect-ratio="16 / 9" class="grey lighten-2" alt="img">
				<template v-slot:placeholder>
					<v-row class="fill-height ma-0" align="center" justify="center">
						<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
					</v-row>
				</template>
			</v-img>
		</v-carousel-item>
	</v-carousel>
</template>

<script>
export default {
	name: 'Carousel',
	data() {
		return {
			slides: [
				require('@/assets/images/img_29.jpg'),
				require('@/assets/images/img_30.jpg'),
				require('@/assets/images/img_31.jpg'),
				require('@/assets/images/img_32.jpg'),
			].reverse(),
		}
	},
}
</script>

<style lang="scss" scoped></style>
